import { reactive } from 'vue'

const registry = reactive({})

export function resetWaitKeys (keys = []) {
  keys.forEach((key) => {
    registry[key] = false
  })
}

export function createWaitPlugin () {
  return {
    install (app) {
      const wait = {
        start (key) {
          registry[key] = true
        },
        end (key) {
          registry[key] = false
        },
        is (key) {
          return !!registry[key]
        }
      }

      app.config.globalProperties.$wait = wait
      app.provide('waitRegistry', registry)

      app.component('VWait', {
        name: 'VWait',
        props: {
          for: { type: String, required: true }
        },
        inject: ['waitRegistry'],
        computed: {
          isWaiting () {
            return !!this.waitRegistry[this.for]
          }
        },
        render () {
          if (this.isWaiting) {
            return this.$slots.waiting ? this.$slots.waiting() : null
          }
          return this.$slots.default ? this.$slots.default() : null
        }
      })
    }
  }
}
